export default {
  title: {
    id: 'address_book_rules_confirmation_title',
    defaultMessage: 'Summary',
  },
  activity: {
    id: 'address_book_rules_confirmation_activity',
    defaultMessage: 'Activity',
  },
  productReturn: {
    id: 'address_book_rules_activity_product_return',
    defaultMessage: 'Product Return',
  },
  productRefund: {
    id: 'address_book_rules_activity_product_refund',
    defaultMessage: 'Product Refund',
  },
  productRepair: {
    id: 'address_book_rules_activity_product_repair',
    defaultMessage: 'Product Repair',
  },
  buyback: {
    id: 'address_book_rules_activity_buyback',
    defaultMessage: 'BuyBack',
  },
  backship: {
    id: 'address_book_rules_activity_backship',
    defaultMessage: 'BackShip',
  },
  markets: {
    id: 'address_book_rules_confirmation_markets',
    defaultMessage: 'Markets',
  },
  allMarkets: {
    id: 'address_book_rules_all_markets_label',
    defaultMessage: 'All markets',
  },
  categories: {
    id: 'address_book_rules_confirmation_categories',
    defaultMessage: 'Categories',
  },
  allCategories: {
    id: 'address_book_rules_all_categories_label',
    defaultMessage: 'All categories',
  },
  address: {
    id: 'address_book_rules_confirmation_address',
    defaultMessage:
      'All generated labels for this scenario will be edited for this address:',
  },
  errorTitle: {
    id: 'address_book_delete_error_title',
    defaultMessage: 'Oops, something went wrong.',
  },
  create: {
    id: 'address_book_rules_confirmation_cta',
    defaultMessage: 'Create this rule',
  },
  edit: {
    id: 'address_book_rules_confirmation_cta_edit',
    defaultMessage: 'Edit this rule',
  },
}
